import styled from 'styled-components'
import { Color } from 'root-constants'
import { Button } from 'components/Button'

export const StyledFacedWithFeelings = {
  Wrapper: styled.div`
    position: relative;
    max-width: 360px;
    margin: 0 auto;
    padding: 0 16px 40px;
    z-index: 2;
  `,
  Title: styled.h1`
    margin: 40px 0 24px;
    font-weight: 500;
    font-size: 24px;
    line-height: 33px;
    color: ${Color.WHITE};
  `,
  Subtitle: styled.h2`
    margin-bottom: 42px;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: ${Color.WHITE};
  `,
  Button: styled(Button)`
    font-weight: 600;
    font-size: 20px;
    line-height: 28px;
  `,
}
